// extracted by mini-css-extract-plugin
export default {"arrow":"arrow-538d"};